import React from 'react'

// Work around "graphql" being a big no-no-word for gatsby and mdx
// by adding an alias we can use to make prism highlight graphql code
export const usePrismGqlAlias = (prism) => {
    prism.languages['gql-gatsby-compat'] = prism.languages['graphql'];
}
